export default __webpack_public_path__ + "static/media/_DSC0242.9a675b86.JPG";